import React, { useEffect } from 'react';
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';
import { useSelector, useDispatch } from 'react-redux'
import useReactRouter from 'use-react-router';
import { Button, Typography, Snackbar } from '@material-ui/core';
import { makeStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import CodeIcon from '@material-ui/icons/Code';
import axios from '../../Helpers/Axiosbase';
import * as actions from '../../Store/Actions'
import "./styles.css";
import MuiAlert from '@material-ui/lab/Alert';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';
import ace from 'brace';
import 'brace/mode/json';
import 'brace/theme/github';

//Form Routing

import NavmenuForm from './NavmenuForm';
import EntityCreateForm from './EntityCreateForm'
import WizardEntityCreateForm from './WizardEntityCreateForm'
import EntityHeaderForm from './EntityHeaderForm'
import EntitySearchResultForm from './EntitySearchResultForm'
import { Switch, Route, Redirect } from 'react-router-dom';

//Fullscreen
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const theme = createMuiTheme({
    typography: {
        subtitle1: {
            fontSize: 20,
            fontStyle: 'bold',
        },
    }
});
const useStyles = makeStyles(theme => ({
    btnall: {
        // marginTop: theme.spacing(1),
        top: -35,
        // marginBottom: theme.spacing(1),
        marginRight: theme.spacing(1),
        fontSize: '0.600rem',
    },
    div: {
        marginRight: '15px',
        float: 'right',
    },
    btncancle: {
        fontSize: '0.600rem',
        // marginTop: theme.spacing(1),
        top: -35,
        // marginBottom: theme.spacing(1),
    },
    btnformview: {
        // float:'right',
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
        fontSize: '0.600rem',
    },
    typ: {
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1),
        // marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    btnfullscreen:{
        fontSize: '0.600rem',
        left:450,
        top: -35,
        marginBottom: theme.spacing(1),
    }
}));

export default function ManageConfig(props) {
    const reduxAuth = useSelector((state) => state.auth)
    const appcomponent = useSelector((state) => state.appcomponent)
    const { location, history } = useReactRouter();
    const classes = useStyles();
    const dispatch = useDispatch();
    const [errorMessage, setErrorMessage] = React.useState({
        open: false,
        errmsg: null,
    });

    const [openJSONView, setOpenJSONView] = React.useState({
        open: false,
    });

    const [toggleView, setToggleView] = React.useState({
        view: 'form',
    });

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
    };

    const [change, setChange] = React.useState({
        jsonData: location.state.jsonDocument != "" ? location.state.jsonDocument.data.contexts[0].jsonData : []
    })

    const handlebtnClick = () => {
        reduxAuth.fullscreentoggle=false
        history.push('/Config')
    }
    const handleOnChange = (event) => {
        setChange({
            jsonData: event
        })
    }
    const handleViewBtnClick = (event) => {
        if (event === 'form') {
            setToggleView({
                view: 'form'
            })
            setOpenJSONView({
                open: false
            })
        }
        if (event === 'json') {
            setToggleView({
                view: 'json'
            })
            setOpenJSONView({
                open: true
            })
        }

    }
    const handleSaveBtnClick = () => {
        // const locdata=null;

        if (location.state.jsonDocument != "") {
            let url = "configurationUpdate"
            let postdata = null;
            const locdata = JSON.stringify(location.state.jsonDocument.data.contexts[0].jsonData);
            const statedata = JSON.stringify(change.jsonData);

            if (locdata != statedata) {
                location.state.isPublished = false;
                location.state.jsonDocument.data.contexts[0].jsonData = change.jsonData;
                postdata = {
                    ...location.state,
                    token: reduxAuth.token,
                    userId: reduxAuth.userId
                }
                axios.post(url, postdata)
                    .then(editConfigResponse => {
                        dispatch(actions.configuration());
                        history.push('/Config')

                    })
                    .catch(err => {
                        console.log(err);
                        if (typeof err.response != "object") {
                            setErrorMessage({
                                open: true,
                                // errmsg:err
                            })
                            console.log(err);
                        }
                        else {
                            if (err.response.status === 403) {
                                dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                            }
                        }
                    });
            }

        }
        else {
            history.push('/Config')
        }
        reduxAuth.fullscreentoggle=false
        history.push('/Config')

    }

    const handlefullscreen=(value)=>{
        if(value==="Fullscreen")
        {
            reduxAuth.fullscreentoggle=true
        }
        else{
            reduxAuth.fullscreentoggle=false
        }
        history.push("./ManageConfig",location.state)
    }


    return (
        <div>
            <Snackbar
                open={errorMessage.open} autoHideDuration={3000} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                onClose={handleClose}>
                <Alert
                    severity="error"
                    color="error"
                    variant="filled">
                    {errorMessage.errmsg != null ? errorMessage.errmsg : " NetWork Error:Please Check Your Internet Connection"}
                </Alert>
            </Snackbar>

            <div className={classes.typ}>
                <ThemeProvider theme={theme}>
                    <Typography variant="subtitle1">
                        {appcomponent.selectedApp.displayName}&gt;&gt;{appcomponent.selectedComponent.componentContextCode}
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            aria-label="View"
                            className={classes.btnformview}
                            startIcon={toggleView.view === 'form' ? <CodeIcon /> : <SpeakerNotesIcon />}
                            onClick={(event) => handleViewBtnClick(toggleView.view === 'form' ? 'json' : 'form')}>
                            {toggleView.view === 'form' ? 'JSON' : 'Form'}
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            className={classes.btnformview}
                            startIcon={reduxAuth.fullscreentoggle===false?<FullscreenIcon />:<FullscreenExitIcon/>}
                            onClick={(event)=>handlefullscreen(reduxAuth.fullscreentoggle===false?"Fullscreen":"FullscreenExit")}
                            >
                                {reduxAuth.fullscreentoggle===false?"Fullscreen":"FullscreenExit"}
                        </Button>
                    </Typography>
                </ThemeProvider>
            </div>
            {openJSONView.open ?
                <div className={classes.div}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        aria-label="Save"
                        className={classes.btnall}
                        startIcon={<SaveIcon />}
                        onClick={() => handleSaveBtnClick()}>
                        Save
                </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        className={classes.btncancle}
                        startIcon={<CancelIcon />}
                        onClick={() => handlebtnClick()}>
                        Cancel
                </Button>
                </div> : null}
          
                    <main>
                        {openJSONView.open ?
                            <div
                                style={{ backgroundColor: '#FFFFFF'}}>
                                <Editor
                                    mode='code'
                                    ace={ace}
                                    value={location.state.jsonDocument != "" ? location.state.jsonDocument.data.contexts[0].jsonData : []}
                                    onChange={(event) => handleOnChange(event)}>
                                </Editor>
                            </div>
                            :
                            <div 
                            style={{ overflowY: 'auto', backgroundColor: '#FFFFFF' }}>
                                {appcomponent.selectedComponent.componentContextCode === "rock-navmenu" ? <NavmenuForm /> : null}
                                {appcomponent.selectedComponent.componentContextCode === "rock-entity-create" ? <EntityCreateForm /> : null}
                                {appcomponent.selectedComponent.componentContextCode === "rock-wizard-entity-create" ? <WizardEntityCreateForm /> : null}
                                {appcomponent.selectedComponent.componentContextCode === "rock-entity-header" ? <EntityHeaderForm /> : null}
                                {appcomponent.selectedComponent.componentContextCode === "rock-entity-search-result" ? <EntitySearchResultForm /> : null}
                                {appcomponent.selectedComponent.componentContextCode !== "rock-navmenu" &&
                                    appcomponent.selectedComponent.componentContextCode !== "rock-entity-create" &&
                                    appcomponent.selectedComponent.componentContextCode !== "rock-wizard-entity-create" &&
                                    appcomponent.selectedComponent.componentContextCode !== "rock-entity-header" &&
                                    appcomponent.selectedComponent.componentContextCode !== "rock-entity-search-result" ?
                                    setOpenJSONView({
                                        open: true
                                    })

                                    : null}
                            </div>
                        }

                    </main>
               
        </div>
    )
}